// The Notion draft without its "If it asks, my code is…" line: v0 attributes
// by link only, so there is no code to type.
export const referralShareMessage = (link: string): string =>
  `I used Granted to check my medical bill. Sign up with my link and set up your first case, and we'll both get a $20 gift card: ${link}`;
